import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const locales = {
	en: {
		// '模板库': 'Tempalte Library',
		// '互动课件平台': 'iTextbook',
		// '退出': 'signout',
		// '通过': 'Pass',
		// '驳回': 'Reject',
		'发布': 'Publish',
		'预览': 'Preview',
		'编辑': 'Edit',
		// '禁用': 'Disabled'
	},
	zh: {
		'模板库': '模板库',
		'教材库': '教材库',
		'互动课件平台': '互动课件平台',
		'退出': '退出',
		'通过': '通过',
		'驳回': '驳回',
		'发布': '发布',
		'预览': '预览',
		'编辑': '编辑',
		'禁用': '禁用'
	}
};


/**
 * 获取用户浏览器语言
 *
 * @returns 
 */
function lang() {
	const userLang = navigator.language || navigator.userLanguage;
	return userLang.split('-')[0];
}

// set locales
Object.keys(locales).forEach(function (lang) {
	Vue.locale(lang, locales[lang]);
});

Vue.config.lang = lang();

export {
	lang
};

export default locales;